import React from 'react';
import * as styles from '../styles/tag.module.scss';

interface Props {
  label: string;
  className?: string;
}

const Tag: React.FC<Props> = ({ label, className }) => {
  return <span className={`${styles.tag} ${className}`}>{label}</span>;
};

export default Tag;
